import React from 'react';
import { Switch} from 'react-router-dom';
// import ConfigurationProcess from './main-components/ConfigurationProcess';
// import ManageUser from './main-components/ManageUser';
import generateStyles from './styles';

const Main = (props: any) => {
    const useStyles = generateStyles();
    const classes = useStyles();
    return (
        <div className={classes.content}>
            {/* <Toolbar /> */}
            <main className={classes.main}>
                <Switch>
                    {props.children}
                </Switch>
            </main>
        </div>
    );
};

export default Main;